
<div class="wrapper bg-white">
    <div class="container-fluid px-0">
        <div class="announcement-wrapper">
        </div>
    </div>
    <router-outlet></router-outlet>
</div>

